export const FETCH_EXPLORE_TRIPS_SUCCESS = 'FETCH_EXPLORE_TRIPS_SUCCESS'
export const FETCH_MORE_EXPLORE_TRIPS_SUCCESS = 'FETCH_MORE_EXPLORE_TRIPS_SUCCESS'
export const FETCH_EXPLORE_AIRBNB_SUCCESS = 'FETCH_EXPLORE_AIRBNB_SUCCESS'
export const FETCH_MORE_EXPLORE_AIRBNB_SUCCESS = 'FETCH_MORE_EXPLORE_AIRBNB_SUCCESS'
export const FETCH_DESTINATION_SUCCESS = 'FETCH_DESTINATION_SUCCESS'
export const FETCH_POPULAR_ITEMS_SUCCESS = 'FETCH_POPULAR_ITEMS_SUCCESS'
